var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicFormBuilder',{attrs:{"hideDetails":"","form":_vm.form},on:{"change":function($event){return _vm.dataChanged($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }